import { FlatNode, Tree } from '../pages/mindmap/types';

/**
 * Gets a tree's root node and converts it into a flat node (omits children).
 * @param tree
 * @returns FlatNode The tree's root node as a FlatNode
 */
export const treeRootToFlatNode = (tree: Tree): FlatNode => {
  return {
    version: tree.version,
    id: tree.id,
    text: tree.text,
    height: tree.height,
    width: tree.width,
    pid: tree.pid,
    x: tree.x,
    y: tree.y,
    type: tree.type,
    attachementMinHeight: tree.attachementMinHeight,
    attachementMinWidth: tree.attachementMinWidth,
    previewMinHeight: tree.previewMinHeight,
    previewMinWidth: tree.previewMinWidth,
    textMinHeight: tree.textMinHeight,
    textMinWidth: tree.textMinWidth,
    attachements: tree.attachements,
  };
};
